import formatTime, { parseTimeFormat } from 'helpers/formatTime';
import React, { useState, ChangeEvent } from 'react';
import { FormattedMessage } from 'react-intl';

import ActionLink from 'styled/components/ActionLink';
import TextInput from 'styled/components/TextInput';

import { MatchTimeInputProps } from './MatchTimeInputTypes';
import StyledMatchTimeInput from './StyledMatchTimeInput';
import { MatchStatus, noTimeMatchStatuses } from '../../enums/matchStatus';

const MatchTimeInput: React.FC<MatchTimeInputProps> = ({ time, matchStatusId, onUpdate }) => {
  const [showTimeInput, setShowTimeInput] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);
  const [newTime, setNewTime] = useState('');
  const updateTimeFormat = /^((\d{0,3}:)?\d{0,2}|\d{0,3})$/;
  const strictTimeFormat = /^\d{0,3}:[0-5][0-9]$/;

  const updateInput = (event: ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;

    if (
      ![MatchStatus.FIRST_HALF_EXTRA_TIME, MatchStatus.SECOND_HALF_EXTRA_TIME, MatchStatus.PENALTIES].includes(
        matchStatusId,
      )
    ) {
      if (newTime.length === 1 && value.length === 2 && !value.includes(':')) {
        value += ':';
      }
    } else {
      if (newTime.length === 2 && value.length === 3 && !value.includes(':')) {
        value += ':';
      }
    }

    if (updateTimeFormat.test(value)) {
      setNewTime(value);
      if (strictTimeFormat.test(value)) {
        setIsInvalid(false);
      } else {
        setIsInvalid(true);
      }
    }
  };

  const updateTime = () => {
    if (strictTimeFormat.test(newTime)) {
      setShowTimeInput(false);
      const time = parseTimeFormat(newTime);
      onUpdate(time);
    }
  };

  const disableEditTime = noTimeMatchStatuses.indexOf(matchStatusId) > -1;

  return (
    <StyledMatchTimeInput>
      {showTimeInput ? (
        <div className="input">
          <TextInput
            tiny
            type="string"
            value={newTime}
            onChange={updateInput}
            onKeyUp={(event) => {
              if (event.key === 'Enter') {
                updateTime();
              }
              if (event.key === 'Escape') {
                setShowTimeInput(false);
              }
            }}
            autoFocus
          />
          <ActionLink onClick={updateTime} disabled={isInvalid}>
            Ok
          </ActionLink>
        </div>
      ) : (
        <ActionLink
          disabled={disableEditTime}
          onClick={() => {
            setNewTime(formatTime(time.minutes, time.seconds));
            setShowTimeInput(true);
          }}
        >
          <FormattedMessage id="actions.setTime" />
        </ActionLink>
      )}
    </StyledMatchTimeInput>
  );
};

export default MatchTimeInput;
